import { cn } from '../../utils/utils';

const Loader = ({ className }) => {
  return (
    <div
      className={cn(
        'border-4 border-primary !border-t-transparent w-8 h-8 border-opacity-25 rounded-full animate-spin mx-auto',
        className
      )}
    ></div>
  );
};

export default Loader;
